import React, { useState, useCallback } from 'react';
import { Link } from '@reach/router';

import { HeaderContainer } from 'utils/style/extendable';

import {
  isOutPatientDomain,
  outpatientContent,
  getAppTitle,
  getDomainAndPort,
} from 'api/Utils';
import { getRedirectToLoginPath } from 'utils/happyFunctions';

import {
  Container,
  HeaderItem,
  HeaderSearchWrapper,
  MenuDivider,
  MenuItem,
  MenuLink,
  PopoverButton,
  PopoverMenu,
  StyledIcon,
  UserName,
  UserNameList,
} from './styles';
import messages from './Messages';
import RouteMatch from './RouteMatch';
import Icon from 'components/Icon';
import Dropdown from 'components/Dropdown';
import Avatar from 'components/Avatar';
import Pill from '../Pill/Pill';
import { IThisUser } from 'store/store';
import { IUser } from 'store/users/usersType';

type ComponentProps = {
  renderSearchBox?: JSX.Element;
  thisUser?: IThisUser;
  user: IUser;
};

const domainAndPort = getDomainAndPort();
const isOutpatientView = isOutPatientDomain();

const appTitle = getAppTitle();

const MainHeader: React.FunctionComponent<ComponentProps> = ({
  renderSearchBox,
  thisUser,
  user,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleShowDropdownCallback = useCallback(
    (show: boolean) => {
      setShowDropdown(show);
    },
    [setShowDropdown]
  );

  const handleClickOnMenuItem = () => {
    setShowDropdown(false);
  };

  const handleClickOnMenuItemCallback = useCallback(handleClickOnMenuItem, [
    handleClickOnMenuItem,
  ]);

  const showUserId =
    domainAndPort.domainFeatures && domainAndPort.domainFeatures.showUserId;
  return (
    <HeaderContainer>
      <Container>
        <RouteMatch />
        {!isOutpatientView && (
          <HeaderSearchWrapper>
            {renderSearchBox ? renderSearchBox : <span>{appTitle}</span>}
          </HeaderSearchWrapper>
        )}
        {thisUser && thisUser.isLoggedIn ? (
          <HeaderItem>
            <Dropdown
              curveBorder={true}
              marginToTarget={4}
              placement="bottom"
              width={120}
              show={showDropdown}
              onShowChange={handleShowDropdownCallback}
              target={
                <PopoverButton>
                  <StyledIcon type="chevron-down" />
                  <UserName>
                    {thisUser.name || (user && user.name) || messages.user}
                    {showUserId && '(' + thisUser.userId + ')'}
                  </UserName>
                  <Avatar icon="user" customStyle={{ marginRight: '0.5rem' }} />
                </PopoverButton>
              }
            >
              <PopoverMenu>
                {showUserId && (
                  <UserNameList>
                    {thisUser.name || (user && user.name) || messages.user}
                    <Pill>
                      {messages.code}
                      {thisUser.userId}
                    </Pill>
                  </UserNameList>
                )}
                <MenuLink
                  path={isOutpatientView ? outpatientContent : '/homepage'}
                >
                  <MenuItem onClick={handleClickOnMenuItemCallback}>
                    <Icon type="home" />
                    {messages.home}
                  </MenuItem>
                </MenuLink>
                <MenuLink exact={true} path="/c/profile">
                  <MenuItem onClick={handleClickOnMenuItemCallback}>
                    <Icon type="user" />
                    {messages.profile}
                  </MenuItem>
                </MenuLink>
                {!isOutpatientView && (
                  <MenuLink path="/c/company/list">
                    <MenuItem onClick={handleClickOnMenuItemCallback}>
                      <Icon type="briefcase" />
                      {messages.companies}
                    </MenuItem>
                  </MenuLink>
                )}
                <MenuDivider />
                <MenuLink path="/logout">
                  <MenuItem onClick={handleClickOnMenuItemCallback}>
                    <Icon type="log-out" />
                    {messages.exit}
                  </MenuItem>
                </MenuLink>
              </PopoverMenu>
            </Dropdown>
          </HeaderItem>
        ) : (
          <HeaderItem>
            <Link to={getRedirectToLoginPath()}>{messages.login}</Link>
          </HeaderItem>
        )}
      </Container>
    </HeaderContainer>
  );
};

export default MainHeader;
